import { createFileRoute } from "@tanstack/react-router";
import ProjectsPage from "@/pages/ProjectsPage";
import { buildHead, SITE_URL } from "@/lib/seo-head";

export const Route = createFileRoute("/projects/")({
  head: () =>
    buildHead({
      title: "Interior Fit-Out Project Portfolio | Abacus Bahrain & GCC",
      description:
        "Delivered interior fit-out projects by Abacus: luxury retail boutiques, corporate offices, banks, F&B and hospitality interiors across Bahrain and the GCC.",
      path: "/projects",
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Abacus Design Solutions Projects",
        url: `${SITE_URL}/projects`,
      },
    }),
  component: ProjectsPage,
});
